<template>
  <v-btn
    :color="color"
    @click="goLink()"
  >
    {{ $t('OchPowerAccountTerms') }}
    <v-icon
      small
      class="ml-1"
      icon="mdi-launch"
    />
  </v-btn>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    components: {},
    mixins: [],
    props: {
      color: { type: String, default: 'secondary' }
    },
    data: () => ({}),
    computed: {
      ...mapGetters(['ui'])
    },
    created () {},
    mounted () {},
    methods: {
      goLink () {
        let lang = this.$i18n.locale
        let fqdn = location.protocol + '//' + location.host
        window.open(`${fqdn}/terms/${lang}`, '_blank')
      }
    }
  }
</script>

<style scoped>

</style>
